import auth from "./auth";
import common from "./common";
import domain from "./domain";
import errors from "./errors";
import nav from "./nav";

export const en = { common, nav, auth, errors, domain } as const;
